var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWellnessNavIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.5698C5.015 14.5698 6.431 14.2678 7.32 14.9198L9.082 16.2098C9.737 16.6898 10.446 16.5318 11.177 16.4178C12.139 16.2668 13 17.0878 13 18.1558C13 18.4478 10.927 19.1908 10.628 19.3318C10.3401 19.468 10.0205 19.523 9.70369 19.4909C9.38685 19.4588 9.08477 19.3409 8.83 19.1498L6.842 17.6928",
    stroke: "#97A5A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.5L17.091 15.61C17.4518 15.4853 17.8409 15.4676 18.2116 15.559C18.5822 15.6504 18.9185 15.8469 19.18 16.125L19.85 16.826C20.09 17.076 20.034 17.498 19.737 17.67L11.883 22.231C11.651 22.367 11.3935 22.4538 11.1264 22.4859C10.8594 22.5181 10.5887 22.495 10.331 22.418L4 20.527M12.002 12.5C12.002 12.5 14.102 10.261 14.102 7.5C14.102 4.739 12.002 2.5 12.002 2.5C12.002 2.5 9.902 4.739 9.902 7.5C9.902 10.261 12.002 12.5 12.002 12.5ZM12.002 12.5C12.002 12.5 15.069 12.432 17.002 10.46C18.935 8.487 19.002 5.357 19.002 5.357C19.002 5.357 17.732 5.385 16.312 5.931M12.002 12.5C12.002 12.5 8.935 12.432 7.002 10.46C5.069 8.487 5.002 5.357 5.002 5.357C5.002 5.357 6.272 5.385 7.692 5.931",
    stroke: "#97A5A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellnessNavIcon);
export default __webpack_public_path__ + "static/media/Wellness_Nav_Icon.5525a8b898b235e389de094433e77d92.svg";
export { ForwardRef as ReactComponent };